import isEmpty from "lodash/isEmpty"
export const getPayloadforDeleteDoc = (id, key) => {
  return {
    [key]: [
      {
        id,
      },
    ],
  }
}

export const getPayloadforAddDoc = (id, key) => {
  return {
    [id]: [
      {
        infoType: key,
      },
    ],
  }
}

export const getPayloadforRoutingCountry = (id,orderNumber) => {
  return {
    [id]: [
      {
        "countryCode":"GB" ,
         orderNumber,
      },
    ],
  }
}

export const getValidShipmentFields = (data)=>{
let result ={}
if(data){
  for (const [key, value] of Object.entries(data)) {
  
    if(!isEmpty(value)){
      result = {...result,[key]:value}
    }
    
  }
}
return result
}

